/**
 * Some API Gateway setups return Lambda `isBase64Encoded` payloads as literal
 * base64 **text** in the HTTP body (not decoded to octets). That yields ~4/3
 * larger files that are not valid images/PDFs until decoded.
 *
 * If the entire body (ignoring whitespace) is strict base64, returns decoded bytes.
 */
export async function decodeBlobIfEntireBase64Ascii(
  blob: Blob,
  maxSizeBytes = 25 * 1024 * 1024,
): Promise<Uint8Array | null> {
  if (blob.size > maxSizeBytes) return null;
  const text = (await new Response(blob).text()).replace(/\s+/g, "");
  if (text.length < 4 || text.length % 4 !== 0) return null;
  if (!/^[A-Za-z0-9+/]+={0,2}$/.test(text)) return null;
  try {
    const bin = atob(text);
    const u = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i += 1) {
      u[i] = bin.charCodeAt(i);
    }
    return u;
  } catch {
    return null;
  }
}
